import React from 'react';
import ActiveJobs from './ActiveJobs';

const Jobs = () => (
  <div>
    <ActiveJobs />
  </div>
);

export default Jobs;
